'use strict';

exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Log Filter Definitions
 * @description defined filter sets for ELK logging
 * could be extended for PaymentProperties or Account Properties, etc.
 */
var elkLogFilterDefinitions = function elkLogFilterDefinitions() {
  _classCallCheck(this, elkLogFilterDefinitions);
};

elkLogFilterDefinitions.PiiProperties = ['firstName', 'lastName'];
exports.default = elkLogFilterDefinitions;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/elk/log.filter.definitions.js
// module id = 895
// module chunks = 0